module.exports = __webpack_public_path__ + "img/1.95db2075.jpg";